<div class="main-container">
  <!-- <div id="hubspotForm"> </div> -->
  @if (showForm) {
    <div class="register-form-container">
      <div class="form-header">
        <h1 class="form-title">Contractor Registration</h1>
        <p class="form-subtitle">Please complete all required fields to register</p>
      </div>
      <div class="required-note">
        <strong>Note:</strong> Fields marked with <span class="required">*</span> are mandatory
      </div>
      <form [formGroup]="contactForm" (submit)="submitForm()">
        <div class="form-grid">
          <div class="form-group">
            <label for="firstName">First Name <span class="required">*</span></label>
            <input type="text" id="firstName" name="firstName" class="form-input" placeholder="First name" formControlName="firstName"
              [ngClass]="{'is-invalid': contactForm.get('firstName')?.invalid && contactForm.get('firstName')?.touched }" required>
              <cx-form-errors [control]="contactForm.get('firstName')"></cx-form-errors>
            </div>
            <div class="form-group">
              <label for="lastName">
                Last Name <span class="required">*</span>
              </label>
              <input type="text" id="lastName" name="lastName" class="form-input" placeholder="Last name" formControlName="lastName"
                [ngClass]="{'is-invalid': contactForm.get('lastName')?.invalid && contactForm.get('lastName')?.touched}" required>
                <cx-form-errors [control]="contactForm.get('lastName')"></cx-form-errors>
              </div>
            </div>
            <div class="form-grid">
              <div class="form-group">
                <label for="companyName">Company Name <span class="required">*</span></label>
                <input type="text" id="companyName" name="companyName" class="form-input" placeholder="Company name" formControlName="companyName"
                  [ngClass]="{'is-invalid': contactForm.get('companyName')?.invalid && contactForm.get('companyName')?.touched}" required>
                  <cx-form-errors [control]="contactForm.get('companyName')"></cx-form-errors>
                </div>
                <div class="form-group">
                  <label for="email">Email Address <span class="required">*</span></label>
                  <input type="text" id="email" name="email" class="form-input" placeholder="example@gmail.com" formControlName="email"
                    [ngClass]="{'is-invalid': contactForm.get('email')?.invalid && contactForm.get('email')?.touched}" required>
                    <cx-form-errors [control]="contactForm.get('email')"></cx-form-errors>
                  </div>
                </div>
                <div class="form-grid-phones">
                  <div class="form-group">
                    <label for="mobilePhone">Telephone Number <span class="required">*</span></label>
                    <input type="text" id="mobilePhone" name="mobilePhone" class="form-input" placeholder="(124)-456-7656" formControlName="mobilePhone"
                      [ngClass]="{'is-invalid': contactForm.get('mobilePhone')?.invalid && contactForm.get('mobilePhone')?.touched}" required>
                      <cx-form-errors [control]="contactForm.get('mobilePhone')"></cx-form-errors>
                    </div>
                    <div class="form-group">
                      <label for="faxNumber">Fax Number</label>
                      <input type="text" id="faxNumber" name="faxNumber" class="form-input" placeholder="(124)-456-7656" formControlName="faxNumber">
                    </div>
                    <div class="form-group">
                      <label for="otherNumber">Other Number</label>
                      <input type="text" id="otherNumber" name="otherNumber" class="form-input" placeholder="(124)-456-7656" formControlName="otherNumber">
                    </div>
                  </div>
                  <div class="form-grid">
                    <div class="form-group">
                      <label for="addressLine1">
                        Address Line 1 <span class="required">*</span>
                      </label>
                      <input type="text" id="addressLine1" name="addressLine1" class="form-input" placeholder="123 Main st" formControlName="addressLine1"
                        [ngClass]="{'is-invalid': contactForm.get('addressLine1')?.invalid && contactForm.get('addressLine1')?.touched }" required>
                        <cx-form-errors [control]="contactForm.get('addressLine1')"></cx-form-errors>
                      </div>
                      <div class="form-group">
                        <label for="addressLine2">Address Line 2</label>
                        <input type="text" id="addressLine2" name="addressLine2" class="form-input" formControlName="addressLine2">
                      </div>
                    </div>
                    <div class="form-grid">
                      <div class="form-group">
                        <label for="city">City <span class="required">*</span></label>
                        <input type="text" id="city" name="city" class="form-input" placeholder="City" formControlName="city"
                          [ngClass]="{'is-invalid': contactForm.get('city')?.invalid && contactForm.get('city')?.touched}" required>
                          <cx-form-errors [control]="contactForm.get('city')"></cx-form-errors>
                        </div>
                        <div class="form-group"
                          [ngClass]="{ 'is-invalid': contactForm.get('state')?.invalid && contactForm.get('state')?.touched }">
                          <label for="state">
                            State <span class="required">*</span>
                          </label>
                          <ng-select id="state" [items]="stateData" bindLabel="name" bindValue="isocodeShort" formControlName="state"
                            placeholder="Select State">
                          </ng-select>
                          <cx-form-errors [control]="contactForm.get('state')"></cx-form-errors>
                        </div>
                      </div>
                      <div class="form-grid">
                        <div class="form-group">
                          <label for="zipcode">
                            Zip Code <span class="required">*</span>
                          </label>
                          <input type="text" id="zipcode" name="zipcode" class="form-input" placeholder="12345" formControlName="zipcode"
                            [ngClass]="{'is-invalid': contactForm.get('zipcode')?.invalid && contactForm.get('zipcode')?.touched}" required>
                            <cx-form-errors [control]="contactForm.get('zipcode')"></cx-form-errors>
                          </div>
                          <div class="form-group">
                            <label for="url">URL</label>
                            <input type="url" id="url" name="url" class="form-input" formControlName="url" placeholder="https://">
                          </div>
                        </div>
                        <div class="form-group full-width">
                          <label>
                            Type of Entity <span class="required">*</span>
                          </label>
                          <div class="radio-group">
                            @for (option of entityOptions; track option) {
                              <div class="radio-option">
                                <input type="radio" class="radio-input" placeholder="Entity Name" [id]="option.value" [value]="option.value"
                                  formControlName="entityType" />
                                  <label class="radio-label" [for]="option.value">{{ option.label }}</label>
                                </div>
                              }
                            </div>
                          </div>
                          <div class="form-grid">
                            <div class="form-group">
                              <label for="federalTaxId">Federal Tax ID</label>
                              <input type="text" id="federalTaxId" name="federalTaxId" class="form-input" formControlName="federalTaxId" placeholder="XX-XXXXXXX">
                            </div>
                            <div class="form-group">
                              <label for="contractorLicense">
                                Contractor License Number <span class="required">*</span>
                              </label>
                              <input type="text" id="contractorLicense" name="contractorLicense" placeholder="123456789" class="form-input" formControlName="contractorLicense"
                                [ngClass]="{'is-invalid': contactForm.get('contractorLicense')?.invalid && contactForm.get('contractorLicense')?.touched}" required>
                                <cx-form-errors [control]="contactForm.get('contractorLicense')"></cx-form-errors>
                              </div>
                            </div>
                            <div class="form-grid">
                              <div class="form-group">
                                <label for="dateBegan">Date Business Began</label>
                                <input type="date" id="dateBegan" name="dateBegan" class="form-input" formControlName="dateBegan">
                              </div>
                              <div class="form-group">
                                <label for="dateCurrentManagement">Date under Current Management</label>
                                <input type="date" id="dateCurrentManagement" name="dateCurrentManagement" class="form-input"
                                  formControlName="dateCurrentManagement">
                                </div>
                              </div>
                              <div class="submit-container">
                                <button type="submit" class="submit-btn">Submit Registration</button>
                              </div>
                            </form>
                          </div>
                        }

                        @if ({ spinnerActive : knBrCommonService.showInlineSpinner$ | async }; as $) {
                          @if ($.spinnerActive == 'registration-loader') {
                            <knbr-cwt-spinner class="cart-spinner-backdrop" [calssName]="'registration-loader'"></knbr-cwt-spinner>
                          }
                        }

                        @if (showSuccessOrFailureContent) {
                          <div class="message-container">
                            <h1 class="success-title">{{ successContent ? successTitle : failureTitle }}</h1>
                            <div class="success-details" [ngClass]="{'error-details': userExistsContent}">
                              <strong>{{ successContent ? successContent1 : failureContent }}</strong>
                              <br><br>
                              @if (successContent) {
                                <span>{{successContent2}}</span>
                              }
                            </div>
                            <a href="#" class="login-link" onclick="navigateToLogin()">Go to Login Page</a>
                          </div>
                        }
                      </div>